import api from '../services/axios.service';

/**
 * Fetches all Kafka users.
 * @returns {Promise<Object[]>} List of Kafka user objects.
 */
export async function fetchKafkaUsers() {
    return api.get('kafka-access/kafka-users');
}

/**
 * Creates a new Kafka user.
 * @param {Object} user - The user payload.
 * @param {string} user.username
 * @param {string} user.password
 * @param {string} user.whitelist_ips
 * @param {Object[]} [user.kafka_acls]
 * @returns {Promise<Object>} Created user object.
 */
export async function createKafkaUser(user) {
    return api.post('kafka-access/kafka-users', user);
}

/**
 * Updates a Kafka user.
 * @param {string} username - The username of the user to update.
 * @param {Object} user - The update payload.
 * @returns {Promise<Object>} Updated user object.
 */
export async function updateKafkaUser(username, user) {
    return api.put(`kafka-access/kafka-users/${username}`, user);
}

/**
 * Deletes a Kafka user.
 * @param {string} username - The username of the user to delete.
 * @returns {Promise<Object>} Delete response.
 */
export async function deleteKafkaUser(username) {
    return api.delete(`kafka-access/kafka-users/${username}`);
}
